(() => {
	'use strict';

	//===========================
	// TOP3スライダー
	//===========================
	const initTop3Slider = () => {
		const dataPref = 'data-slider_top3';
		const slider = document.querySelector(`[${dataPref}]`);
		const slides = document.querySelectorAll(`[${dataPref}-slide]`);

		if (slides.length < 2) {
			return;
		}

		const prevButton = document.querySelector(`[${dataPref}-prev]`);
		const nextButton = document.querySelector(`[${dataPref}-next]`);
		const pagination = document.querySelector(`[${dataPref}-pagination]`);

		const swiper = new Swiper(slider, {
			centeredSlides: true,
			loop: true,
			slidesPerView: 'auto',
			allowTouchMove: true,
			spaceBetween: 10,
			navigation: {
				nextEl: nextButton,
				prevEl: prevButton,
			},
			pagination: {
				el: pagination,
				bulletClass: 'top3-slider__pagination-bullet',
				bulletActiveClass: 'is-active',
				clickable: true,
			},
			breakpoints: {
				769: {
					spaceBetween: 23,
				},
			},
		});
	};

	//===========================
	// アコーディオン
	//===========================
	const toggleAccordion = () => {
		document.querySelectorAll(`[data-accordion-trigger]`).forEach((trigger) => {
			trigger.addEventListener('click', () => {
				trigger.classList.toggle('is-open');
			});
		});
	};

	initTop3Slider();
	toggleAccordion();
})();
